import { useBreakpoint } from '@frontend/responsiveness';
import { insuranceAccordionSectionContainerStyles } from './styles';

type InsuranceSectionFilterContainerProps = {
  children: React.ReactNode;
};
export const InsuranceSectionFilterContainer = ({ children }: InsuranceSectionFilterContainerProps) => {
  const breakpoints = useBreakpoint();
  const isSmallDevice = breakpoints === 'small' || breakpoints === 'xsmall';

  return <div css={insuranceAccordionSectionContainerStyles(isSmallDevice)}>{children}</div>;
};
